import { Navigate, RouteObject } from 'react-router';

import { DefaultLayout } from '@/ui/pages/app/components/layouts/DefaultLayout.tsx';
import { Contact } from '@/ui/pages/app/contact/Contact.tsx';
import { CreateOrganisation } from '@/ui/pages/app/organisation/CreateOrganisation';
import { Welcome } from '@/ui/pages/app/welcome/Welcome';

import { appIndexLoader } from './appLoaders';
import { festivalRoutes } from './festival/festivalRoutes';
import { tourRoutes } from './tour/tourRoutes';
import { venueRoutes } from './venue/venueRoutes';

export const appRoutes: RouteObject[] = [
  {
    path: '',
    index: true,
    loader: appIndexLoader,
    element: <p>...</p>,
  },
  {
    path: 'create-organisation',
    element: <CreateOrganisation />,
  },
  {
    path: 'welcome',
    element: (
      <DefaultLayout>
        <Welcome />
      </DefaultLayout>
    ),
  },
  {
    path: 'projects',
    element: <Navigate to="festival" replace />,
  },
  {
    path: 'contact',
    element: (
      <DefaultLayout enableTrialOut>
        <Contact />
      </DefaultLayout>
    ),
  },
  ...festivalRoutes,
  ...venueRoutes,
  ...tourRoutes,
];
